import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://assets.cdn.filesafe.space/F6iXsZYsDLnX3HpNjkIU/media/69db664fb30bc52371159e72.png";

const SIZES = {
  sm: 32,
  md: 44,
  lg: 64,
};

export default function Logo({ size = "md", linkTo = "/", className = "", testId = "logo" }) {
  const h = SIZES[size] || SIZES.md;
  const inner = (
    <img
      src={LOGO_URL}
      alt="Antiaging by BB"
      data-testid={testId}
      style={{ height: h, width: "auto", display: "block" }}
      className={className}
    />
  );
  if (linkTo === null) return inner;
  return <Link to={linkTo} style={{ textDecoration: "none", display: "inline-flex", alignItems: "center" }}>{inner}</Link>;
}
